import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { msg } from 'api';

import PageStatistic from 'apps/analytics/components/PageStatistic';
import { wa, pageEventTypes } from 'apps/analytics';

import getDeviceName from 'utils/getDeviceName';
import { Consumer } from 'utils/BowserProvider';

export class AppBannerInternal extends PureComponent {
  static propTypes = {
    bowser: PropTypes.object.isRequired,
    isVisible: PropTypes.bool,
    onCloseClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isVisible: true,
  };

  handleLinkClick = () => {
    const { bowser } = this.props;

    wa.triggerPageEvent(pageEventTypes.APP_BANNER_REDIRECT_TO_STORE, {
      DEVICE: getDeviceName(bowser),
    });
  };

  handleCloseClick = () => {
    const { bowser, onCloseClick } = this.props;

    wa.triggerPageEvent(pageEventTypes.APP_BANNER_CLOSED, {
      DEVICE: getDeviceName(bowser),
    });

    onCloseClick();
  };

  trackAppBannerVisible = () => <PageStatistic field="IS_APP_BANNER_VISIBLE" value />;

  render() {
    const { isVisible } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <div className="hd-appBanner">
        {this.trackAppBannerVisible()}
        <div className="hd-appBanner__content">
          <div className="hd-appBanner__logo" />
          <div className="hd-appBanner__desc">
            <p className="hd-appBanner__descTitle">
              {msg.user.mobileAppBanner.bannerHeading}
            </p>
            {msg.user.mobileAppBanner.bannerMessage && (
              <p className="hd-appBanner__descText">{ msg.user.mobileAppBanner.bannerMessage }</p>
            )}
          </div>
          <a
            className="hd-appBanner__link btn-tertiary"
            href="/webshop/getMobileApp.do"
            onClick={this.handleLinkClick}
          >
            {msg.user.mobileAppBanner.goToStoreButtonText}
          </a>
          <button
            aria-label="Close"
            className="hd-appBanner__close"
            onClick={this.handleCloseClick}
          />
        </div>
      </div>
    );
  }
}

const AppBanner = (props) => (
  <Consumer>
    {bowser => <AppBannerInternal bowser={bowser} {...props} />}
  </Consumer>
);

export default AppBanner;
